import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot } from 'lexical'
import { $convertFromMarkdownString } from '@lexical/markdown'

export function ContentPastePlugin() {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const handlePaste = (event: ClipboardEvent) => {
      const clipboardData = event.clipboardData
      if (!clipboardData) return

      const html = clipboardData.getData('text/html')
      const plainText = clipboardData.getData('text/plain')

      if (html) {
        return
      }

      event.preventDefault()

      editor.update(() => {
        const root = $getRoot()
        root.clear()
        $convertFromMarkdownString(plainText)
      })
    }

    const removeEventListener = editor.registerRootListener(rootElement => {
      if (rootElement !== null) {
        rootElement.addEventListener('paste', handlePaste)
      }
    })

    return () => {
      removeEventListener()
    }
  }, [editor])

  return null
}
